// extracted by mini-css-extract-plugin
export var hideEditor = "_lb-2";
export var infoIcon = "_lb-3";
export var label = "_lb-1";
export var labelContainer = "_lb-0";
export var readonlyText = "_lb-4";